import { LitElement } from "lit";

export class AnNamElement extends LitElement {
  createRenderRoot(): this {
    return this;
  }
}
